import { React, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Transitions from "./Transitions";
import ContactCTA from "./ContactCTA";
import { SectionHeader } from "./Header";
import { GalleryCard } from "./WorkCard";
import TEEimg from "../img/TEE_mockup.png";
import NeuroImg from "../img/neuro_demo.gif";
import CPRimg from "../img/CPR_clip1.gif";
import HErectusImg from "../img/HErectus_thumb.jpg";
import EverestImg from "../img/everest_scroll.gif";
import EndocarditisImg from "../img/patho_comp_thumb.png";
import SciRobotics from "../img/scirobotics_thumb.jpg";
import Medical3D from "../img/misc3D_thumb.gif";
import SelfEcorche from "../img/selfecorche.gif";
import NeuroThumb from "../img/Neuro_thumb.jpg";

function Work() {
  // useEffect(() => {
  //   document.title = "ETCHNG | Work";

  // }, []);

  return (
    <>
      <Helmet>
        <title>ETCHNG | Work</title>
        <meta name="description" content="Gallery of work" />
        <meta name="keywords" content="medical illustrator, Eric Chung " />
      </Helmet>
      <Transitions>
        <div className="wrapper">
          <div className="wrapper__inner">
            <SectionHeader
              textColour="#f55a59"
              smallText="Recent"
              largeText="WORK"
            ></SectionHeader>
            <div className="gallery">
              <Link to="/work/TEEsim">
                <GalleryCard
                  photo_icon={TEEimg}
                  photo_alt="TEE"
                  name="Developing a transesophageal echocardiography simulator for medical education"
                  category="UI/UX |  3D | Animation | Unity"
                  type="Web app"
                ></GalleryCard>
              </Link>
              <Link to="/work/MediapipeNeuro">
                <GalleryCard
                  photo_icon={NeuroImg}
                  photo_alt="Neuro"
                  name="Using machine learning to create a gesture-controlled neuroanatomy atlas"
                  category="UI/UX |  3D |  Tensorflow.js "
                  type="Web app"
                ></GalleryCard>{" "}
              </Link>
              <Link to="/work/CPRassist">
                <GalleryCard
                  photo_icon={CPRimg}
                  photo_alt="CPR"
                  name="Assisting CPR rescuers with guided steps and simulated scenarios"
                  category="UI/UX |  3D |  Unity "
                  type="Mobile app"
                ></GalleryCard>
              </Link>
              <Link to="/work/HErectus">
                <GalleryCard
                  photo_icon={HErectusImg}
                  photo_alt="Homo Erectus"
                  name="Predicting Peking Man: An anthropological approximation of "
                  italics="H. erectus"
                  name2=" using forensic data"
                  category="3D"
                  type="Print spread"
                ></GalleryCard>
              </Link>
              <Link to="/work/DeathZone">
                <GalleryCard
                  photo_icon={EverestImg}
                  photo_alt="Everest"
                  name="Data storytelling of high-altitude physiology on Mt. Everest"
                  category="UI/UX |  3D"
                  type="WebGL microsite"
                ></GalleryCard>{" "}
              </Link>
              <Link to="/work/Endocarditis">
                <GalleryCard
                  photo_icon={EndocarditisImg}
                  photo_alt="Endocarditis mockup"
                  name="Engaging readers on infective endocarditis using WebAR"
                  category="UI/UX | Illustration"
                  type="Print & WebAR app"
                ></GalleryCard>{" "}
              </Link>

              <Link to="/work/SelfEcorche">
                <GalleryCard
                  photo_icon={SelfEcorche}
                  photo_alt="Self-ecorche"
                  name="Self-écorché: An anatomical self-portrait"
                  category="3D"
                  type="Animation"
                ></GalleryCard>
              </Link>
              <Link to="/work/MiscMedical">
                <GalleryCard
                  photo_icon={Medical3D}
                  photo_alt="Medical 3D animation"
                  name="Miscellaneous Medical 3D"
                  category="3D"
                  type="Animation"
                ></GalleryCard>
              </Link>

              <Link to="/work/SciRobotics">
                <GalleryCard
                  photo_icon={SciRobotics}
                  photo_alt="Everest"
                  name="Promoting the role of competition-driven robotics in rehabilition research"
                  category="3D"
                  type="Editorial cover"
                ></GalleryCard>{" "}
              </Link>
              <Link to="/work/MedIllus">
                <GalleryCard
                  photo_icon={NeuroThumb}
                  photo_alt="Various medical illustration"
                  name="Print medical illustrations"
                  category="Illustration"
                  type="Print spread"
                ></GalleryCard>
              </Link>
            </div>
            <ContactCTA />
          </div>
        </div>
      </Transitions>
    </>
  );
}

export default Work;
